import { EmployeeProvidedDocs } from '../../../application/domain/entities/EmployeeProvidedDocs';
import { SaveEmployeeProvidedDocsCommand } from '../../../application/domain/entities/SaveEmployeeProvidedDocsCommand';
import {
  EmployeeProvidedDocsGetResponseDto,
  EmployeeProvidedDocsPostResponseDto,
} from '../dto/res/EmployeeProvidedDocsResponseDto';
import { EmployeeProvidedDocsRequestDto } from '../dto/req/EmployeeProvidedDocsRequestDto';
import { safeDateParse } from '@/shared/infra/utils/utils';

/** Map GET response to domain entity */
export function mapGetDtoToEntity(
  dto: EmployeeProvidedDocsGetResponseDto
): EmployeeProvidedDocs {
  return {
    i9FormId: dto.i9FormId,
    employeeProvidedDocsId: dto.employeeProvidedDocsId,
    listADocKey: dto.listADocKey,
    listADocMetadata: dto.listADocMetadata,
    listBDocKey: dto.listBDocKey,
    listBDocMetadata: dto.listBDocMetadata,
    listCDocKey: dto.listCDocKey,
    listCDocMetadata: dto.listCDocMetadata,
    lastUpdatedAt: safeDateParse(dto.lastUpdatedAt) as Date,
  };
}

/** Map POST response (same shape as GET) to domain entity */
export function mapPostDtoToEntity(dto: EmployeeProvidedDocsPostResponseDto): EmployeeProvidedDocs {
  return {
    i9FormId: dto.i9FormId,
    employeeProvidedDocsId: dto.employeeProvidedDocsId,
    listADocKey: dto.listADocKey,
    listADocMetadata: dto.listADocMetadata,
    listBDocKey: dto.listBDocKey,
    listBDocMetadata: dto.listBDocMetadata,
    listCDocKey: dto.listCDocKey,
    listCDocMetadata: dto.listCDocMetadata,
    lastUpdatedAt: safeDateParse(dto.lastUpdatedAt) as Date,
  };
}

/** Map domain command to POST request DTO */
export function mapCommandToRequestDto(
  command: SaveEmployeeProvidedDocsCommand
): EmployeeProvidedDocsRequestDto {
  return {
    i9FormId: command.i9FormId,
    listADocKey: command.listADocKey ?? null,
    listADocMetadata: command.listADocMetadata ?? null,
    listBDocKey: command.listBDocKey ?? null,
    listBDocMetadata: command.listBDocMetadata ?? null,
    listCDocKey: command.listCDocKey ?? null,
    listCDocMetadata: command.listCDocMetadata ?? null,
  };
}
